import AppImage from '@/components/ui/AppImage';

export default function FounderDesk() {
  return (
    <section className="py-20 md:py-32 bg-zinc-950 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 reveal">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-[2px] h-4 bg-gradient-to-b from-pink-500 to-purple-600" />
            <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
              From Founder's Desk
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-white">
            Our Vision for<br />
            <span className="bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
              Digital Excellence
            </span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Founder Photo */}
          <div className="reveal">
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-pink-500 to-purple-600 rounded-3xl blur opacity-25 group-hover:opacity-40 transition duration-500" />
              <div className="relative bg-zinc-900 border border-zinc-800 rounded-3xl overflow-hidden">
                <AppImage
                  src="/assets/images/60822d72-37c1-4d72-9205-f84af8d30a0e-1771410060442.jpg"
                  alt="Founder of Classic24 Digital Solutions with arms crossed wearing dark t-shirt in outdoor setting"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>

          {/* Founder Message */}
          <div className="reveal space-y-6">
            <div className="space-y-4">
              <p className="text-lg md:text-xl text-zinc-300 leading-relaxed">
                At Classic24 Digital Solutions, we are driven by a singular vision: to deliver exceptional service and innovative creative strategies that empower businesses worldwide.
              </p>
              <p className="text-lg md:text-xl text-zinc-300 leading-relaxed">
                Our commitment goes beyond creating digital solutions—we craft experiences that transform brands, engage audiences, and drive measurable results. Every project is an opportunity to push boundaries and set new standards of excellence.
              </p>
              <p className="text-lg md:text-xl text-zinc-300 leading-relaxed">
                With a foundation built on technical expertise and creative innovation, we partner with businesses to navigate the ever-evolving digital landscape and achieve sustainable growth.
              </p>
            </div>

            {/* Founder Details */}
            <div className="pt-6 border-t border-zinc-800">
              <div className="space-y-2">
                <h3 className="text-2xl font-bold text-white">Pankaj Jhamnani</h3>
                <p className="text-pink-500 font-semibold">Founder & CEO</p>
                <p className="text-zinc-400 text-sm">Classic24 Digital Solutions</p>
                <div className="flex items-center gap-2 text-zinc-400">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
                  </svg>
                  <span className="text-sm">Bachelor of Engineering (B.E.), Mumbai University</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}